module.exports = __webpack_public_path__ + "static/hello-fresh-dc24d0f3d1a1b9665244d76058ffb43d.png";